import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import { CardPageLayout } from "component-lib/CardPageLayout";
import {
	LabeledButtonWithCountMultiple,
	DealStatusModule,
	DEAL_STATUSES,
	DEAL_STAGES,
	COMPANY_LEVELS,
	PROPERTY_ASSET_TYPES,
	LOAN_SENIORITY_TYPES,
	LOAN_STATUSES,
	GUEST_PERMISSIONS,
	InputText,
	ButtonText,
	InputTypeAhead
} from "@loanbossinc/component-library";
import CommentIcon from "@material-ui/icons/Comment";
import AttachmentIcon from "@material-ui/icons/AttachFile";
import AlarmIcon from "@material-ui/icons/Alarm";
import LockIcon from "@material-ui/icons/Lock";
import { withLDConsumer } from "launchdarkly-react-client-sdk";

import DrawerAttachments from "modals/DrawerAttachments/DrawerAttachments";
import { DrawerNotes } from "modals/DrawerNotes/DrawerNotes";
import { FeatureLockedModal } from "modals/FeatureLockedModal";
import DealSharingModal from 'modals/DealSharing';
import ReminderModule from "modules/reminder/reminder";
import PeopleModule from "modules/people/people";
import PropertyModule from "modules/property/property";
import DealDebtValuationModule from "modules/debtValuation/DealDebtValuation";
import PaidLoanModule from "modules/paidLoan/paidLoan";
import QuoteModule from "modules/quote/quote";
import { mapCompanySelector, mapGuestPermissions } from "store/state/auth";
import {
	dealGet,
	dealGetAlerts,
	dealGetAttachments,
	dealPutAttachment,
	dealPostAttachment,
	dealDeleteAttachment,
	dealGetNotes,
	dealPutNote,
	dealPostNote,
	dealDeleteNote,
	cancelDealRefinance,
	reviveDeal,
	killDeal,
	changeDealStage,
	getWinningQuotes,
	closeDeal,
	cancelModifyLoans,
	dealPostImage,
	dealDeleteImage,
	addSupplementalLoans,
	cancelAddSupplemental,
	clearStore,
	getDealName,
	deleteDeal,
	downloadLoans,
	getAllCompanies,
	shareDeal,
	deleteDealShare,
	getAppActivationStatus
} from "./deal.store";
import { getPermissionedUserByCompanyId } from "pages/lenderReportingDashboard/lenderReportingDashboard.store";
import { getLoansByPreferenceAndLoanSeniority } from "store/state/loan/loan";
import ActiveLoan from "../../modules/activeLoan/activeLoan";
import heroCardMetrics from "./heroCardMetrics";
import { GenericHeroCard } from "component-lib/";
import AddEditAlert from "components/Notifications/AddEditAlert";
import ChangeDealStatusModal from "../../modals/ChangeDealStatusModal/ChangeDealStatusModal";
import PickAWinnerModal from "../../modals/ChangeDealStatusModal/PickAWinnerModal";
import CloseDealRefiModal from "../../modals/CloseRefiModal/CloseDealRefiModal";
import SimpleConfirmDialog from "../../components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import ModifyLoansModal from "../../modals/ChangeDealStatusModal/ModifyLoansModal";
import CompleteLoanModificationModal from "../../modals/ChangeDealStatusModal/CompleteLoanModificationModal";
import { formatForCompare } from "./deal.helper";
import pagesHelper from "utils/pagesHelper";
import { SimpleInfoModal } from 'modals/SimpleInfoModal';
import { trackLoanSummariesDownload } from "lib/mixpanel";
import featureFlags from "../../constants/featureFlags";
import { getEnvConfig } from "helpers/environment-config";
import { convertIntegerToGUID } from "helpers/guid";

const StyledModuleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledLabeledButtonWithCountMultiple = styled(LabeledButtonWithCountMultiple)`
  margin-top: 2em;
`;
const StyledInputTypeAhead = styled(InputTypeAhead)`
width: 190px;
`;
const StyledButtonText = styled(ButtonText)`&&&{
  margin-right:24px;

  background: #FFFFFF;
  /* Stroke / LB Blue */

  border: 1px solid #005AA9;
  box-sizing: border-box;
  border-radius: 4px;
  .MuiButton-label{
    flex-direction: row-reverse;
  }
  .material-icons{
    margin-left: 0;
    margin-right: .2em;
  }
  .label{
    margin-right: 5px;
  }
}`;
const ActionButtonWrapper = styled.div`
  && {
    display: flex;
    flex-direction: row;
	margin-bottom: 16px
  }
`;
const StyledBodyWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;
const StyledTitleSection = styled.div`
  && {
    display: flex;
    flex-direction: row;

    .title {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      align-items: center;
      text-align: center;

      color: #000000;
    }
  }
`;

const DEAL_MODAL_ATTACHMENTS = "DEAL_MODAL_ATTACHMENTS";
const DEAL_MODAL_NOTES = "DEAL_MODAL_NOTES";
const ALERTS_MODAL = "ALERTS_MODAL";
const CHANGE_STATUS_MODAL = "CHANGE_STATUS_MODAL";
const PICK_A_WINNER_MODAL = "PICK_A_WINNER_MODAL";
const FEATURE_LOCKED_MODAL = "FEATURE_LOCKED_MODAL";
const CONFIRM_DIALOG_MODAL = "CONFIRM_DIALOG_MODAL";
const CLOSE_DEAL_REFI_MODAL = "CLOSE_DEAL_REFI_MODAL";
const MODIFY_LOANS_MODAL = "MODIFY_LOANS_MODAL";
const COMPLETE_LOAN_MODIFICATION_MODAL = "COMPLETE_LOAN_MODIFICATION_MODAL";
const SIMPLE_INFO_MODAL = "SIMPLE_INFO_MODAL";
const DEAL_SHARING_MODAL = "DEAL_SHARING_MODAL";

class Deal extends Component {
	state = {
		heroCardDealMetrics: [],
		openModal: { name: null, data: null },
		dealHeroCardButtons: [],
		winningQuotesRequested: false,
		dialogState: {
			handleNo: null,
			handleYes: null,
			title: "",
			message: "",
			secondaryContent: "",
			noText: "No",
			yesText: "Yes, Confirm"
		},
		confirmationModal: {
			title: "",
			onClose: () => { },
			onAccept: () => { },
			content: "",
			disableAccept: true
		},
		deleteDealConfirm: "",
		companySharedTo: null
	};

	componentDidMount() {
		if(!this.props.appActivation) {
			this.props.getAppActivationStatus();
		}
		const { dealId } = this.props.match.params;
		// this.props.getDealName({ dealId });
		this.props.getAllCompanies();
		this.props.dealGet({ dealId });
		this.props.dealGetNotes({ dealId });
		this.props.dealGetAlerts({ dealId, isAlert: true });
		this.props.dealGetAttachments({ dealId });
		this.props.getPermissionedUserByCompanyId();

		const curriedSeniorQuery = this.getLoansBySeniority(this.getComparableLoanColumns(), "comparable_senior_loans", LOAN_SENIORITY_TYPES.SENIOR);
		curriedSeniorQuery(0, 100);
		const curriedMezzQuery = this.getLoansBySeniority(this.getComparableLoanColumns(), "comparable_mezz_loans", LOAN_SENIORITY_TYPES.SUBORDINATE);
		curriedMezzQuery(0, 100);
		const curriedSupplementalQuery = this.getLoansBySeniority(
			this.getComparableLoanColumns(),
			"comparable_supplemental_loans",
			LOAN_SENIORITY_TYPES.SUPPLEMENTAL
		);
		curriedSupplementalQuery(0, 100);

		this.getPaginatedSenior(0, 10, "ASC");
		this.getPaginatedMezz(0, 10, "ASC");
		this.getPaginatedSubsidy(0, 10, "ASC");
		this.getPaginatedSupplemental(0, 10, "ASC");
		this.setState({ winningQuotesRequested: false });
	}

	getComparableLoanColumns = () => ["amount", "loanTermMonths", "rateTypeId"];

	componentDidUpdate(prevProps) {
		const { dealId } = this.props.match.params;
		if (this.props !== prevProps) {
			this.findMetrics();
			this.setHeroCardButtons();
			const inClosing = !this.props.authentication.isGuest && this.props.deal && this.props.deal.stageId === DEAL_STAGES.IN_CLOSING;
			if (inClosing && (!this.props.winningQuotes || this.props.winningQuotes.length === 0) && !this.state.winningQuotesRequested) {
				this.props.getWinningQuotes({ dealId });
				this.setState({ winningQuotesRequested: true });
			}
		}
	}

	componentWillUnmount() {
		this.props.clearStore();
	}

	getPaginatedSenior = (page, pageSize, sortOrder) => {
		const curriedQuery = this.getLoansBySeniority(null, "senior_loan_table", LOAN_SENIORITY_TYPES.SENIOR);
		curriedQuery(page, pageSize, sortOrder);
	};

	getPaginatedMezz = (page, pageSize, sortOrder) => {
		const curriedQuery = this.getLoansBySeniority(null, "mezz_loan_table", LOAN_SENIORITY_TYPES.SUBORDINATE);
		curriedQuery(page, pageSize, sortOrder);
	};

	getPaginatedSubsidy = (page, pageSize, sortOrder) => {
		const curriedQuery = this.getLoansBySeniority(null, "subsidy_loan_table", LOAN_SENIORITY_TYPES.SUBSIDY);
		curriedQuery(page, pageSize, sortOrder);
	};

	getPaginatedSupplemental = (page, pageSize, sortOrder) => {
		const curriedQuery = this.getLoansBySeniority(null, "supplemental_loan_table", LOAN_SENIORITY_TYPES.SUPPLEMENTAL);
		curriedQuery(page, pageSize, sortOrder);
	};

	getLoansBySeniority = (desiredColumns, subKey, loanSeniorityId) => {
		const { dealId } = this.props.match.params;
		return (page, pageSize, sortOrder) => {
			this.props.getLoansByPreferenceAndLoanSeniority({
				subKey,
				dealId,
				loanSeniorityId,
				columns: desiredColumns,
				page,
				pageSize,
				sortOrder,
				includePassedRejected: this.props.authentication.isGuest && this.props.guestPermissions && !this.props.guestPermissions.pipelineAllowQuoteStatus
			});
		};
	};

	getLenderReportingPermissions(authentication, isSystemAdmin, permissionedUsersByCompany, contactId) {
		if (authentication && !isSystemAdmin) {
			return !!permissionedUsersByCompany.find(user => user.contactId === contactId);
		}
		return true;
	}

	setHeroCardButtons() {
		const { deal, history, authentication, guestPermission, permissionedUsersByCompany } = this.props;
		const { dealId } = this.props.match.params;
		const contactId = authentication?.user?.contact?.id;
    const isSystemAdmin = authentication?.isSystemAdmin;
		const lenderReportingPermissions = this.getLenderReportingPermissions(authentication, isSystemAdmin, permissionedUsersByCompany, contactId);

		if (!deal || !deal.dealStatusId) return null;

		const { dealStatusId } = deal;
		const propertyCount = deal.properties.length;

    const hideMetricsButton =
      (
        this.props.flags[featureFlags.GLA453_USE_NEW_METRICS] ||
        this.props.flags[featureFlags.GLA453_CLIENTS_WHO_USE_NEW_METRICS]?.includes(this.props.authentication.user.contact.companyId)
      ) && !authentication.isSystemAdmin;
		const buttons = [];
		if (
      !hideMetricsButton &&
			propertyCount > 0 &&
			dealStatusId !== DEAL_STATUSES.SOLD &&
			(!authentication.isGuest || (authentication.isGuest && guestPermission && !!guestPermission.portfolioMetricsPermissionId))
		) {
			const metricsAnalysisButton = { label: "Metrics & Analysis", onClick: () => history.push(`/deal/${dealId}/analysis`) };
			buttons.push(metricsAnalysisButton);
		}

		if (dealStatusId === DEAL_STATUSES.CLOSED && !authentication.isGuest) {
			const chageStatusButton = { label: "Change Status", onClick: () => this.openModal(CHANGE_STATUS_MODAL) };
			buttons.push(chageStatusButton);
		}

		if (!authentication.isGuest && this.props.isLenderReportingActive && lenderReportingPermissions) {
			const lenderReportsButton = { label: "Lender Compliance", onClick: () => history.push(`/deal/${dealId}/lender-reports`) };
			buttons.push(lenderReportsButton)
		}

		const deleteButton = this.deleteButton();
		if (deleteButton) buttons.push(deleteButton);
		// Master Cashflows button
		if (authentication.isSystemAdmin || this.props.flags[featureFlags.MASTER_CASHFLOWS_FEATURE]) {

			const masterCashflowsButton = {
				label: "Master Cashflows",
				onClick: async () => {
					const newFrontendUrl = await getEnvConfig("newFrontendUrl");
					const { dealId } = this.props.match.params;

					const convertToGuidIfNumber = (value) => {
						if (!isNaN(Number(value)) && Number.isInteger(Number(value))) {
							return convertIntegerToGUID(Number(value));
						}
						return value;
					};

					const convertedDealId = convertToGuidIfNumber(dealId);
					window.location.assign(`${newFrontendUrl}/cashflows/${convertedDealId}/master`, '_blank');
				}
			};


			buttons.push(masterCashflowsButton);
		}

		this.setState({ dealHeroCardButtons: buttons });
	}

	deleteButton = () => {
		const { authentication } = this.props;
		const { dealId } = this.props.match.params;
		if (!authentication || authentication.isGuest || !authentication.isSystemAdmin) return null;
		return {
			label: "Delete Deal",
			onClick: () => {
				this.openConfirmationDialog("Delete Deal",
					this.closeModal, () => {
						if (this.state.deleteDealConfirm === "DELETE") {
							if (dealId)
								this.props.deleteDeal({ dealId: dealId, callback: () => this.props.history.goBack() });
							this.closeModal();
						}
					},
					(<>
						<p>Deleting a deal will remove all its underlying content and data.</p>
						<p><InputText
							name="dealDeleteConfirm"
							label="Confirm by typing DELETE"
							defaultValue=''
							onChange={(event) => this.setState({
								deleteDealConfirm: event?.target?.value,
								confirmationModal: { ...this.state.confirmationModal, disableAccept: event?.target?.value !== "DELETE" }
							})}
							style={{ width: "462px" }} /></p>
					</>), true
				);
			}
		};
	}

	deleteAttachment = (handleDelete) => {
		const { authentication } = this.props;

		if (!authentication || authentication.isGuest || !authentication.isSystemAdmin) return null;

		this.openModal(SIMPLE_INFO_MODAL);
		this.openConfirmationDialog("Delete Attachment",
			this.closeModal,
			() => {
				handleDelete();
				this.closeModal();
			},
			(<>
				Deleting an attachment will remove all its underlying data.
			</>)
			, false
		)
	}

	openConfirmationDialog = (title, onClose, onAccept, content, disableAccept) => {
		this.setState({ confirmationModal: { title, onClose, onAccept, content, disableAccept: disableAccept } });
		this.openModal(SIMPLE_INFO_MODAL);
	}

	getNotificationOptions = () => {
		const { notes, alerts, attachments, company, authentication } = this.props;
		const isStarter = company.companyLevelId !== COMPANY_LEVELS.PROFESSIONAL
			&& company.companyLevelId !== COMPANY_LEVELS.ENTERPRISE
			&& company.companyLevelId !== COMPANY_LEVELS.SECONDARY_SPONSOR;

		let { notesLength, attachmentsLength } = pagesHelper.getNotesAttachmentCounts(notes, attachments, authentication);

		const buttonList = [
			{
				label: "notes",
				count: notesLength,
				onClick: () => this.openModal(DEAL_MODAL_NOTES),
				icon: <CommentIcon />
			},
			{
				label: "ATTACHMENTS",
				count: attachmentsLength,
				onClick: () => this.openModal(DEAL_MODAL_ATTACHMENTS),
				icon: <AttachmentIcon />
			}
		];

		if (authentication && !authentication.isGuest) {
			buttonList.push({
				label: "ALERTS",
				count: alerts ? alerts.length : 0,
				onClick: () => this.openModal(ALERTS_MODAL),
				icon: <AlarmIcon />
			});
			buttonList.push({
				label: "ALERTS",
				count: alerts ? alerts.length : 0,
				onClick: () => this.openModal(FEATURE_LOCKED_MODAL),
				icon: <LockIcon />,
				disabled: true
			});
		}

		isStarter ? buttonList.splice(2, 1) : buttonList.splice(3, 1);
		return buttonList;
	};

	findMetrics = () => {
		const { deal } = this.props;
		if (!deal || !deal.dealMetrics) return;
		const { dealStatusId } = deal;
		const { projectTypeId } = deal;
		const isMultiFamily = deal.properties.some(p => p.assetTypeId === PROPERTY_ASSET_TYPES.MULTIFAMILY);

		const heroCardDealMetrics = heroCardMetrics.reduce((accum, heroMetric) => {
			const metric = deal.dealMetrics.find(metric => metric.metricId === heroMetric.metricId);
			const shouldInclude =
				heroMetric.activeDealStatus.includes(dealStatusId) &&
				(heroMetric.activeProjectType.length === 0 || heroMetric.activeProjectType.includes(projectTypeId)) &&
				(heroMetric.isMFOnly !== null || (heroMetric.isMFOnly && isMultiFamily));

			if (metric && shouldInclude) accum.push({ ...heroMetric, ...metric });
			else if (shouldInclude) accum.push({ ...heroMetric });

			return accum;
		}, []);

		this.setState({ heroCardDealMetrics });
	};

	// render commands
	closeModal = () => this.setState({ openModal: { name: null, data: null } });
	closeStatusChangeModal = name => {
		this.setState({ openModal: { name, data: null } });
		const { dealId } = this.props.match.params;
		this.props.dealGet({ dealId });
	};
	openModal = (name, data = null) => this.setState({ openModal: { name, data } });
	isModalOpen = modalName => {
		const { openModal } = this.state;
		return openModal.name === modalName;
	};

	cancelStatusChange = () => {
		const { deal } = this.props;
		const { dealId } = this.props.match.params;
		if (!deal || !deal.dealStatusId) return null;

		switch (deal.dealStatusId) {
			case DEAL_STATUSES.REFINANCE:
				this.props.cancelDealRefinance({ dealId: deal.id, callback: () => this.props.dealGet({ dealId }) });
			case DEAL_STATUSES.MODIFYING:
				this.cancelDealModify({ dealId: deal.id, callback: () => this.props.dealGet({ dealId }) });
			case DEAL_STATUSES.ADDING_SUPPLEMENTAL:
				this.cancelDealAddSupp({ dealId: deal.id, callback: () => this.props.dealGet({ dealId }) });
		}

		this.props.dealGet({ dealId });
	};

	killDeal = () => {
		const { dealId } = this.props.match.params;
		this.props.killDeal({ dealId, callback: () => this.props.dealGet({ dealId }) });
	};

	confirmKillDeal = () => {
		this.openModal(CONFIRM_DIALOG_MODAL);
		this.setState({
			dialogState: {
				handleNo: () => this.closeModal(CONFIRM_DIALOG_MODAL),
				handleYes: () => {
					this.killDeal();
					this.closeModal(CONFIRM_DIALOG_MODAL);
				},
				title: "Confirm Cancel",
				message: "You are about to move this deal to Dead status. Are you sure you want to do this?",
				secondaryContent: "Your information will not be lost and you can move it back to active in the future.",
				noText: "No",
				yesText: "Yes, Confirm"
			}
		});
	};

	killDeal = () => {
		const { dealId } = this.props.match.params;
		this.props.killDeal({ dealId, callback: () => this.props.dealGet({ dealId }) });
	};

	changeDealStage = dealStageId => {
		const { dealId } = this.props.match.params;
		this.props.changeDealStage({
			dealId,
			dealStageId,
			callback: () => {
				return this.props.dealGet({ dealId });
			}
		});
	};

	handleRenderChangeStatusModalClose = closeChoice => {
		const { dealId } = this.props.match.params;
		this.closeModal();
		switch (closeChoice) {
			case "sold":
				this.closeModal();
				break;
			case "modify":
				this.openModal(MODIFY_LOANS_MODAL);
				break;
			case "addSupplemental":
				this.props.addSupplementalLoans(dealId, () => this.props.dealGet({ dealId }));
				break;
			case "partialRelease":
				this.closeModal();
			default:
				this.props.dealGet({ dealId });
				break;
		}
	};

	confirmRestoreDeal = dealStatusId => {
		const { dealId } = this.props.match.params;
		this.openModal(CONFIRM_DIALOG_MODAL);
		let newStatus = "";
		switch (dealStatusId) {
			case DEAL_STATUSES.CLOSED:
				newStatus = "Closed";
				break;

			case DEAL_STATUSES.PIPELINE:
			default:
				newStatus = "Pipeline";
				break;
		}

		this.setState({
			dialogState: {
				handleNo: () => this.closeModal(),
				handleYes: () => {
					this.props.reviveDeal({ dealId, dealStatusId, callback: () => this.props.dealGet({ dealId }) });
					this.closeModal();
					this.props.dealGet({ dealId });
				},
				title: "Confirm Reactivate",
				message: `You are about to move this deal to ${newStatus} status. Are you sure you want to do this?`,
				noText: "No",
				yesText: "Yes, Confirm"
			}
		});
	};

	closeDeal = () => {
		const { dealId } = this.props.match.params;
		this.props.closeDeal({ dealId, callback: () => this.props.dealGet({ dealId }) });
	};

	confirmCloseDeal = () => {
		const { deal } = this.props;
		if (deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.REFINANCE) {
			this.openModal(CLOSE_DEAL_REFI_MODAL);
		} else {
			let seniorWinningQuote;
			let subordinateWinningQuote;
			let supplementalWinningQuote;
			if (this.props.winningQuotes) {
				const seniorWinningQuotes = this.props.winningQuotes.filter(loan => loan.loanSeniorityId === LOAN_SENIORITY_TYPES.SENIOR);
				if (seniorWinningQuotes.length === 1) {
					seniorWinningQuote = formatForCompare(seniorWinningQuotes[0]);
				}

				const subordinateWinningQuotes = this.props.winningQuotes.filter(loan => loan.loanSeniorityId === LOAN_SENIORITY_TYPES.SUBORDINATE);
				if (subordinateWinningQuotes.length === 1) {
					subordinateWinningQuote = formatForCompare(subordinateWinningQuotes[0]);
				}

				const supplementalWinningQuotes = this.props.winningQuotes.filter(loan => loan.loanSeniorityId === LOAN_SENIORITY_TYPES.SUPPLEMENTAL || loan.loanSeniorityId === LOAN_SENIORITY_TYPES.SUBSIDY);
				if (supplementalWinningQuotes.length === 1) {
					supplementalWinningQuote = formatForCompare(supplementalWinningQuotes[0]);
				}
			}
			const message = (
				<div>
					You are about to close this deal. This action can only be reverted by a <a href="mailto:support@loanboss.com">LoanBoss Administrator</a>.
					<br />
					<br />
					<div style={{ marginLeft: 30 }}>
						{seniorWinningQuote && (
							<>
								<b>Senior Quote:</b> {!seniorWinningQuote || seniorWinningQuote.title}
								<br />
							</>
						)}
						{subordinateWinningQuote && (
							<>
								<b>Subordinate Quote:</b> {!subordinateWinningQuote || subordinateWinningQuote.title}
								<br />
							</>
						)}
						{supplementalWinningQuote && (
							<>
								<b>Supplemental Quote:</b> {!supplementalWinningQuote || supplementalWinningQuote.title}
								<br />
							</>
						)}
					</div>
					<br />
					Are you sure you want to do this?
					<br />
					<br />
					<b>NOTE:</b> All guests that have been added to this deal will be removed upon clicking &quot;Close Deal&quot;.
				</div>
			);
			this.openModal(CONFIRM_DIALOG_MODAL);
			this.setState({
				dialogState: {
					handleNo: () => this.closeModal(CONFIRM_DIALOG_MODAL),
					handleYes: () => {
						this.closeDeal();
						this.closeModal(CONFIRM_DIALOG_MODAL);
					},
					title: "Confirm Close",
					message,
					noText: "CANCEL",
					yesText: "CLOSE DEAL"
				}
			});
		}
	};

	cancelDealModify = ({ dealId, callback }) => {
		this.openModal(CONFIRM_DIALOG_MODAL);
		this.setState({
			dialogState: {
				handleNo: () => this.closeModal(CONFIRM_DIALOG_MODAL),
				handleYes: () => {
					this.props.cancelModifyLoans(dealId, callback);
					this.closeModal(CONFIRM_DIALOG_MODAL);
				},
				title: "Confirm Cancel",
				message: "You are about to cancel modifications for the loan(s) and all of your changes will be lost.",
				secondaryContent: "Are you sure you want to do this?",
				noText: "No",
				yesText: "Yes, Cancel"
			}
		});
	};

	cancelDealAddSupp = ({ dealId, callback }) => {
		this.openModal(CONFIRM_DIALOG_MODAL);
		this.setState({
			dialogState: {
				handleNo: () => this.closeModal(CONFIRM_DIALOG_MODAL),
				handleYes: () => {
					this.props.cancelAddSupplemental(dealId, callback);
					this.closeModal(CONFIRM_DIALOG_MODAL);
				},
				title: "Confirm Cancel",
				message: "You are about to cancel modifications for this deal and all of your changes will be lost.",
				secondaryContent: "Are you sure you want to do this?",
				noText: "No",
				yesText: "Yes, Cancel"
			}
		});
	};

	isProTier = () => {
		if (this.props.authentication) {
			return this.props.authentication.companyLevel === "Professional"
				|| this.props.authentication.companyLevel === "Enterprise"
				|| this.props.authentication.companyLevel === "Secondary Sponsor";
		}
		return false;
	};

	isBrokerOrSponsor = () => {
		const { authentication } = this.props;

		if (authentication.companyTypes.map(ct => ct.name).includes('Broker'))
			return true;
		if (authentication.companyTypes.map(ct => ct.name).includes('Sponsor'))
			return true;
		return false;
	}

	refreshDealData = (callback) => {
		const { dealId } = this.props.match.params;
		callback();
		this.props.dealGet({ dealId });
		this.props.getDealName({ dealId });
	}

	renderShareComponent = () => {
		const { authentication, deal } = this.props;

		if (!authentication.isSystemAdmin || !this.props.allCompanies || authentication.isGuest || !this.isBrokerOrSponsor())
			return null;

		let message = 'Share';
		if (deal.shared === 1)
			message = `Shared with ${deal?.primaryShare[0]?.secondary?.owningCompany?.name}`
		else if (deal.shared === 2)
			message = `Shared by ${deal?.secondaryShare[0]?.primary?.owningCompany?.name}`

		const isDisabled = !authentication.isSystemAdmin && (authentication.companyTypes.map(ct => ct.name).includes('Sponsor') ||
			authentication.companyLevel === "Secondary Sponsor" ||
			deal.shared !== 0);

		return (
			<>
				<StyledButtonText
					disabled={isDisabled}
					className={"settings-button"}
					label={message}
					onClick={() => this.openModal(DEAL_SHARING_MODAL)}
					iconName={"share"} />
			</>
		)
	}

	footerLeftClick = () => {
		const { deal, authentication } = this.props;

		if (deal.shared === 0 && authentication.companyLevel === "Secondary Sponsor")
			return this.openModal(FEATURE_LOCKED_MODAL);

		switch (deal.dealStatusId) {
			case DEAL_STATUSES.PIPELINE:
				return this.confirmKillDeal();
			case DEAL_STATUSES.MODIFYING:
			case DEAL_STATUSES.REFINANCE:
			case DEAL_STATUSES.ADDING_SUPPLEMENTAL:
				return this.cancelStatusChange();
			case DEAL_STATUSES.SOLD:
				return this.confirmRestoreDeal(DEAL_STATUSES.CLOSED);
			case DEAL_STATUSES.DEAD:
				return this.confirmRestoreDeal(DEAL_STATUSES.PIPELINE);
			case DEAL_STATUSES.CLOSED:
				return null;
		}
	}

	footerRightClick = () => {
		const { deal, authentication } = this.props;

		if (deal.shared === 0 && authentication.companyLevel === "Secondary Sponsor")
			return this.openModal(FEATURE_LOCKED_MODAL);

		if (deal.dealStatusId === DEAL_STATUSES.MODIFYING)
			return this.openModal(COMPLETE_LOAN_MODIFICATION_MODAL)

		let inClosing = !authentication.isGuest && deal.stageId === DEAL_STAGES.IN_CLOSING;
		return !inClosing ? this.openModal(PICK_A_WINNER_MODAL) : this.confirmCloseDeal();
	}


	renderBody = () => {
		const { deal, history, authentication, guestPermission, isDVActive } = this.props;

		if (!deal || !deal.dealStatusId) return null;
		let inClosing = !authentication.isGuest && deal.stageId === DEAL_STAGES.IN_CLOSING;
		const isRefinance = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.REFINANCE;
		// const isAddingSupplemental = deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.ADDING_SUPPLEMENTAL;
		// const isPipeline = deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.PIPELINE;
		// const isModifying = deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.MODIFYING;

		if (isRefinance) {
			if (this.props.seniorLoanData && this.props.seniorLoanData.data && this.props.seniorLoanData.data.loans) {
				this.props.seniorLoanData.data.loans.forEach(quote => {
					if (quote.version === deal.version && quote.loanStatusId === LOAN_STATUSES.IN_CLOSING) {
						// in closing
						inClosing = true;
					}
				});
			}
		}

		const download = (dealId) => {
			this.props.downloadLoans({ dealId });
			trackLoanSummariesDownload();
		};

		switch (deal.dealStatusId) {
			case DEAL_STATUSES.PIPELINE:
				return (
					<StyledModuleContainer>
						<ActionButtonWrapper>
							{/* <StyledButtonText className={"pdf-button"} label={"PDF"} onClick={() => this.props.downloadLoans({ dealId: deal.id })} iconName={"file_download"} /> */}
							{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) &&
								<StyledButtonText className={"settings-button"} label={"Settings"} onClick={() => history.push(`/dealSettings/${deal.id}`)} iconName={"settings"} />}
							{this.renderShareComponent()}
						</ActionButtonWrapper>
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) && (
							<DealStatusModule
								dealStatus={deal.dealStatusId}
								dealStage={deal.stageId}
								isWinningQuote={inClosing}
								footerLeftClick={this.footerLeftClick}
								footerRightClick={this.footerRightClick}
								changeStage={data => this.changeDealStage(data.id)}
								actionsAreLocked={deal.shared === 0 && authentication.companyLevel === "Secondary Sponsor"}
								alignRight={false}
							/>
						)}
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.pipelinePermissionId)) && <QuoteModule />}
						{this.isProTier() && !authentication.isGuest && <ReminderModule />}
						<PropertyModule guestPermission={guestPermission} />
						<PeopleModule />
					</StyledModuleContainer>
				);

			case DEAL_STATUSES.MODIFYING:
				return (
					<StyledModuleContainer>
						<ActionButtonWrapper>
							{/* <StyledButtonText className={"pdf-button"} label={"PDF"} onClick={() => this.props.downloadLoans({ dealId: deal.id })} iconName={"file_download"} /> */}
							{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) &&
								<StyledButtonText className={"settings-button"} label={"Settings"} onClick={() => history.push(`/dealSettings/${deal.id}`)} iconName={"settings"} />}
							{this.renderShareComponent()}
						</ActionButtonWrapper>
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) && (
							<DealStatusModule
								dealStatus={deal.dealStatusId}
								dealStage={deal.stageId}
								isWinningQuote={inClosing}
								footerLeftClick={this.footerLeftClick}
								footerRightClick={this.footerRightClick}
								changeStage={data => this.changeDealStage(data.id)}
								actionsAreLocked={deal.shared === 0 && authentication.companyLevel === "Secondary Sponsor"}
							/>
						)}
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && !!guestPermission.pipelinePermissionId)) && <QuoteModule />}
						<ActiveLoan {...this.props} />
						{this.isProTier() && !authentication.isGuest && <ReminderModule />}
						<PropertyModule guestPermission={guestPermission} deal={this.props.dealName || {}} />
						{isDVActive && <DealDebtValuationModule dealId={deal.id} />}
						<PeopleModule />
						{!authentication.isGuest && <PaidLoanModule />}
					</StyledModuleContainer>
				);
			case DEAL_STATUSES.REFINANCE:
			case DEAL_STATUSES.ADDING_SUPPLEMENTAL:
				return (
					<StyledModuleContainer>
						<ActionButtonWrapper>
							{/* <StyledButtonText className={"pdf-button"} label={"PDF"} onClick={() => this.props.downloadLoans({ dealId: deal.id })} iconName={"file_download"} /> */}
							{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) &&
								<StyledButtonText className={"settings-button"} label={"Settings"} onClick={() => history.push(`/dealSettings/${deal.id}`)} iconName={"settings"} />}
							{this.renderShareComponent()}
						</ActionButtonWrapper>
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) && (
							<DealStatusModule
								dealStatus={deal.dealStatusId}
								dealStage={deal.stageId}
								isWinningQuote={inClosing}
								footerLeftClick={this.footerLeftClick}
								footerRightClick={this.footerRightClick}
								changeStage={data => this.changeDealStage(data.id)}
								actionsAreLocked={deal.shared === 0 && authentication.companyLevel === "Secondary Sponsor"}
							/>
						)}
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && !!guestPermission.pipelinePermissionId)) && <QuoteModule />}
						<ActiveLoan {...this.props} />
						{this.isProTier() && !authentication.isGuest && <ReminderModule />}
						<PropertyModule guestPermission={guestPermission} />
						{isDVActive && <DealDebtValuationModule dealId={deal.id} />}
						<PeopleModule />
						{!authentication.isGuest && <PaidLoanModule />}
					</StyledModuleContainer>
				);

			case DEAL_STATUSES.SOLD:
				return (
					<StyledModuleContainer>
						<ActionButtonWrapper>
							<StyledButtonText className={"pdf-button"} label={"PDF"} onClick={() => download(deal.id)} iconName={"file_download"} />
							{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) &&
								<StyledButtonText className={"settings-button"} label={"Settings"} onClick={() => history.push(`/dealSettings/${deal.id}`)} iconName={"settings"} />}
							{this.renderShareComponent()}
						</ActionButtonWrapper>
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) && (
							<DealStatusModule
								dealStatus={deal.dealStatusId}
								dealStage={deal.stageId}
								isWinningQuote={false}
								footerLeftClick={this.footerLeftClick}
								footerRightClick={() => { }}
								changeStage={() => { }}
								actionsAreLocked={deal.shared === 0 && authentication.companyLevel === "Secondary Sponsor"}
							/>
						)}
						<PaidLoanModule />
						{this.isProTier() && !authentication.isGuest && <ReminderModule />}
						<PropertyModule guestPermission={guestPermission} />
						<PeopleModule />
					</StyledModuleContainer>
				);

			case DEAL_STATUSES.DEAD:
				return (
					<StyledModuleContainer>
						<ActionButtonWrapper>
							{/* <StyledButtonText className={"pdf-button"} label={"PDF"} onClick={() => this.props.downloadLoans({ dealId: deal.id })} iconName={"file_download"} /> */}
							{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) &&
								<StyledButtonText className={"settings-button"} label={"Settings"} onClick={() => history.push(`/dealSettings/${deal.id}`)} iconName={"settings"} />}
							{this.renderShareComponent()}
						</ActionButtonWrapper>
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) && (
							<DealStatusModule
								dealStatus={deal.dealStatusId}
								dealStage={deal.stageId}
								isWinningQuote={false}
								footerLeftClick={this.footerLeftClick}
								actionsAreLocked={deal.shared === 0 && authentication.companyLevel === "Secondary Sponsor"}
							/>
						)}
						{(!authentication.isGuest || (authentication.isGuest && guestPermission && !!guestPermission.pipelinePermissionId)) && <QuoteModule />}
						{this.isProTier() && !authentication.isGuest && <ReminderModule />}
						<PropertyModule guestPermission={guestPermission} />
						<PeopleModule />
					</StyledModuleContainer>
				);

			case DEAL_STATUSES.CLOSED:
			default:
				return (
					<StyledModuleContainer>
						<ActionButtonWrapper>
							<StyledButtonText className={"pdf-button"} label={"PDF"} onClick={() => download(deal.id)} iconName={"file_download"} />
							{(!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT)) &&
								<StyledButtonText className={"settings-button"} label={"Settings"} onClick={() => history.push(`/dealSettings/${deal.id}`)} iconName={"settings"} />}
							{this.renderShareComponent()}
						</ActionButtonWrapper>
						<ActiveLoan {...this.props} />
						{this.isProTier() && !authentication.isGuest && <ReminderModule />}
						<PropertyModule guestPermission={guestPermission} />
						<PeopleModule />
						{isDVActive && <DealDebtValuationModule dealId={deal.id} />}
						{!authentication.isGuest && <PaidLoanModule />}
						<QuoteModule />
					</StyledModuleContainer>
				);
		}
	};

	renderHeroCard = () => {
		const { deal } = this.props;
		return (
			<div>
				<GenericHeroCard {...{ ...this.props, onBackButtonClick: () => this.props.history.push('/DealsDashboard'), buttons: this.state.dealHeroCardButtons, deal, title: deal.name, backLabel: "Deals", displayMetrics: true }} />
				<StyledLabeledButtonWithCountMultiple options={this.getNotificationOptions()} />
			</div>
		);
	};

	getLoanData = key => {
		const loanData = this.props[key].data;
		if (loanData && loanData.loans) return loanData.loans;
		return [];
	};

	render() {
		const { deal, isLoading, authentication} = this.props;
		if (!deal) return null;
		const dealId = deal && deal.id;

		const isAddingSupplemental = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.ADDING_SUPPLEMENTAL;

		return (
			<>
				<CardPageLayout
					{...this.props}
					isReversed
					bannerImageUrl={this.props.deal && this.props.deal.imageLarge}
					cardComponent={this.renderHeroCard()}
					bodyComponent={<StyledBodyWrapper>{this.renderBody()}</StyledBodyWrapper>}
					enableImageChangeDialog
					onImageRemove={() => this.props.dealDeleteImage({ dealId: deal.id })}
					onImageChange={file => this.props.dealPostImage({ dealId: deal.id, file })}
				/>

				<DrawerAttachments
					isOpen={this.isModalOpen(DEAL_MODAL_ATTACHMENTS)}
					deleteAttachment={this.deleteAttachment}
					files={this.props.attachments}
					authentication={this.props.authentication}
					closeDrawer={this.closeModal}
					isLoading={isLoading}
					onAdd={file => this.props.dealPostAttachment({ file, dealId })}
					onUpdate={file => this.props.dealPutAttachment({ file, dealId })}
					onRemove={file => this.props.dealDeleteAttachment({ fileId: file.id, dealId })}
				/>

				<DrawerNotes
					isOpen={this.isModalOpen(DEAL_MODAL_NOTES)}
					notes={this.props.notes}
					authentication={this.props.authentication}
					closeDrawer={this.closeModal}
					onAdd={note => this.props.dealPostNote({ note, dealId })}
					onUpdate={note => this.props.dealPutNote({ note, dealId })}
					onRemove={note => this.props.dealDeleteNote({ noteId: note.id, dealId })}
					type="deal"
				/>

				<FeatureLockedModal isOpen={this.isModalOpen(FEATURE_LOCKED_MODAL)} onClose={this.closeModal} />

				{authentication.isSystemAdmin && <DealSharingModal
					isOpen={this.isModalOpen(DEAL_SHARING_MODAL)}
					onClose={this.closeModal}
					shareDeal={(data) => this.props.shareDeal({ id: deal.id, companySharedTo: data.companySharedToId, callback: () => this.refreshDealData(data.callback) })}
					unShareDeal={(data) => this.props.deleteDealShare({ id: data.dealId, owningCompanyId: data.owningCompanyId, callback: () => this.refreshDealData(data.callback) })}
					deal={this.props.deal}
				/>}

				<ChangeDealStatusModal
					isOpen={this.isModalOpen(CHANGE_STATUS_MODAL)}
					deal={this.props.deal}
					handleClose={this.handleRenderChangeStatusModalClose}
					history={this.props.history}
				/>

				<PickAWinnerModal
					dealId={dealId}
					onClose={this.closeModal}
					seniorLoans={this.getLoanData("comparableSeniorLoans").map(formatForCompare)}
					mezzLoans={this.getLoanData("comparableMezzLoans").map(formatForCompare)}
					supplementalLoans={this.getLoanData("comparableSupplementalLoans").map(formatForCompare)}
					supplementalLoansOnly={isAddingSupplemental}
					refreshGridCallback={() => this.props.dealGet({ dealId })}
					isOpen={this.isModalOpen(PICK_A_WINNER_MODAL)}
					changeDealStage={() => this.changeDealStage(DEAL_STAGES.IN_CLOSING)}
				/>

				<SimpleConfirmDialog
					modalOpen={this.isModalOpen(CONFIRM_DIALOG_MODAL)}
					handleNo={this.state.dialogState.handleNo}
					handleYes={this.state.dialogState.handleYes}
					title={this.state.dialogState.title}
					message={this.state.dialogState.message}
					secondaryContent={this.state.dialogState.secondaryContent}
					noText={this.state.dialogState.noText}
					yesText={this.state.dialogState.yesText}
				/>

				<CloseDealRefiModal
					history={this.props.history}
					dealId={deal.id}
					callback={() => this.props.dealGet({ dealId })}
					isOpen={this.isModalOpen(CLOSE_DEAL_REFI_MODAL)}
					handleClose={() => this.closeModal()}
				/>

				<ModifyLoansModal
					history={this.props.history}
					dealId={deal.id}
					// onClose={() => this.openModal(COMPLETE_LOAN_MODIFICATION_MODAL)}
					onClose={() => this.closeModal()}
					isOpen={this.isModalOpen(MODIFY_LOANS_MODAL)}
				/>

				{this.isModalOpen(COMPLETE_LOAN_MODIFICATION_MODAL) && (
					<CompleteLoanModificationModal dealId={deal.id} onClose={() => this.closeModal()} refreshDeal={() => this.props.dealGet({ dealId: deal.id })} />
				)}

				<AddEditAlert
					key={dealId}
					dealId={dealId}
					notificationId={0}
					isOpen={this.isModalOpen(ALERTS_MODAL)}
					handleCancel={() => {
						this.closeModal(ALERTS_MODAL);
						this.props.dealGetAlerts({ dealId, isAlert: true });
					}}
					handleSave={() => {
						this.closeModal(ALERTS_MODAL);
						this.props.dealGetAlerts({ dealId, isAlert: true });
					}}
					isAlert
					isNew
				/>

				<SimpleInfoModal
					title={this.state.confirmationModal.title}
					isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
					onClose={() => this.state.confirmationModal.onClose()}
					onAccept={() => this.state.confirmationModal.onAccept()}
					content={this.state.confirmationModal.content}
					{...this.state.confirmationModal}
				/>
			</>
		);
	}
}

const mapStateToProps = ({ newDeal, authentication, loading, loan, lenderReportingDashboard }) => ({
	...newDeal,
	guestPermission: mapGuestPermissions(authentication, newDeal.guestPermission),
	company: mapCompanySelector(authentication),
	authentication,
	isLoading: loading.deal_file_upload,

	seniorLoanData: loan.loansByPreference.senior_loan_table || {},
	mezzLoanData: loan.loansByPreference.mezz_loan_table || {},
	subsidyLoanData: loan.loansByPreference.subsidy_loan_table || {},
	supplementalLoanData: loan.loansByPreference.supplemental_loan_table || {},

	comparableSeniorLoans: loan.loansByPreference.comparable_senior_loans || {},
	comparableMezzLoans: loan.loansByPreference.comparable_mezz_loans || {},
	comparableSupplementalLoans: loan.loansByPreference.comparable_supplemental_loans || {},
	permissionedUsersByCompany: lenderReportingDashboard.permissionedUsersByCompany
});

export default compose(
	withRouter,
  withLDConsumer(),
	connect(
		mapStateToProps,
		{
			dealGet,
			dealGetAlerts,

			dealGetAttachments,
			dealPutAttachment,
			dealPostAttachment,
			dealDeleteAttachment,

			dealPostImage,
			dealDeleteImage,

			dealGetNotes,
			dealPutNote,
			dealPostNote,
			dealDeleteNote,
			cancelDealRefinance,
			getLoansByPreferenceAndLoanSeniority,
			reviveDeal,
			killDeal,
			changeDealStage,
			getWinningQuotes,
			closeDeal,
			cancelModifyLoans,
			addSupplementalLoans,
			cancelAddSupplemental,
			clearStore,
			getDealName,
			deleteDeal,
			downloadLoans,
			getAllCompanies,
			shareDeal,
			deleteDealShare,
			getAppActivationStatus,
			getPermissionedUserByCompanyId
		}
	)
)(Deal);
